<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  
  export let label: string;
  export let value: number;
  export let min: number = 0;
  export let max: number | undefined = undefined;
  export let step: number = 1;
  export let placeholder: string = '';
  export let disabled: boolean = false;
  export let icon: any = null; // Optional Tabler icon component

  const dispatch = createEventDispatcher<{ change: number }>();
  let inputElement: HTMLInputElement;
  let inputValue = value.toString();
  const inputId = `input-${Math.random().toString(36).substr(2, 9)}`;

  $: {
    if (value.toString() !== inputValue && document.activeElement !== inputElement) {
      inputValue = value.toString();
    }
  }

  function handleInput(event: Event) {
    const target = event.target as HTMLInputElement;
    inputValue = target.value;
    const numValue = parseFloat(target.value) || 0;
    if (!isNaN(numValue)) {
      const clampedValue = max !== undefined 
        ? Math.min(Math.max(numValue, min), max)
        : Math.max(numValue, min);
      dispatch('change', clampedValue);
    }
  }

  function handleBlur() {
    const numValue = parseFloat(inputValue) || min;
    const clampedValue = max !== undefined 
      ? Math.min(Math.max(numValue, min), max)
      : Math.max(numValue, min);
    inputValue = clampedValue.toString();
    dispatch('change', clampedValue);
  }
</script>

<div class="flex flex-col gap-2">
  <label for={inputId} class="text-sm font-medium text-custom-heading dark:text-white/90 flex items-center gap-2">
    {#if icon}
      <svelte:component this={icon} class="w-4 h-4 icon-accent" />
    {/if}
    {label}
  </label>
  <input
    bind:this={inputElement}
    id={inputId}
    type="number"
    bind:value={inputValue}
    on:input={handleInput}
    on:blur={handleBlur}
    {min}
    {max}
    {step}
    {placeholder}
    {disabled}
    class="glass-input w-full px-4 py-3 rounded-lg placeholder-slate-400 dark:placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500/50 dark:focus:ring-blue-400/50 focus:border-blue-500/50 dark:focus:border-blue-400/50 focus-accent disabled:opacity-50 disabled:cursor-not-allowed transition-all"
  />
</div>
